import PropTypes from 'prop-types';

export const FslBoxPropType = PropTypes.exact({
    letter: PropTypes.string.isRequired,
    phonemes: PropTypes.arrayOf(PropTypes.string),
});

export default FslBoxPropType;
